import React, { useState } from 'react';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import axios from 'axios';

const AddVideoPage = () => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: '',
    subCategory: '',
    videoLink: '',
    image: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formDataUpload = new FormData();
      formDataUpload.append('title', formData.title);
      formDataUpload.append('description', formData.description);
      formDataUpload.append('category', formData.category);
      formDataUpload.append('subCategory', formData.subCategory);
      formDataUpload.append('videoLink', formData.videoLink);
      formDataUpload.append('image', formData.image);

      const response = await axios.post('https://nada.gtechclick.cloud/addVideo', formDataUpload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('Video added successfully:', response.data);
      // Reset form after successful submission (optional)
      setFormData({
        title: '',
        description: '',
        category: '',
        subCategory: '',
        videoLink: '',
        image: null,
      });
    } catch (error) {
      console.error('Error adding video:', error);
      // Handle error state or display error message to user
    }
  };

  return (
    <Container>
      <Row className="justify-content-md-center mt-4">
        <Col xs={10} md={8} lg={6}>
          <h2 className="text-center mb-4">Add New Video</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="videoTitle">
              <Form.Label>Video Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter video title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="videoDescription">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter video description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="videoCategory">
              <Form.Label>Category</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter video category"
                name="category"
                value={formData.category}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="videoSubCategory">
              <Form.Label>Subcategory</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter video subcategory"
                name="subCategory"
                value={formData.subCategory}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="videoLink">
              <Form.Label>Video Link</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter video link"
                name="videoLink"
                value={formData.videoLink}
                onChange={handleChange}
                required
              />
            </Form.Group>
{/* 
            <Form.Group controlId="videoImage">
              <Form.Label>Video Thumbnail</Form.Label>
              <Form.Control
                type="file"
                name="image"
                onChange={handleImageChange}
                required
              />
            </Form.Group> */}

            <Button variant="primary" type="submit" className="mt-3">
              Add Video
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default AddVideoPage;
